import React from "react";
import { Link } from "gatsby";

import useWindowDimensions from "../../../hooks/useWindowDimensions";

import { MenuItemTypes } from "../../../types/layout";

const LinkContainer = ({
  title,
  links,
}: {
  title: string;
  links: MenuItemTypes[];
}) => {
  const { isSmallScreen } = useWindowDimensions();

  return (
    <div>
      <p className="-title footerTitle text-white -mb15">{title}</p>
      <div
        className={`m-footer__links column ${
          isSmallScreen ? "aligned-center -mb20" : ""
        }`}
      >
        {links.map(({ id, name, path }) => (
          <Link to={path} key={id} className="m-footer__links -menu -small">
            {name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default LinkContainer;
